// src/components/RequireInternal.jsx
import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';

function getUser() {
  try { return JSON.parse(localStorage.getItem('user') || '{}'); }
  catch { return {}; }
}

export default function RequireInternal({ children }) {
  const location = useLocation();
  const user = getUser();

  // treat anything truthy/1/"true" as client
  const isClient = !!(
    user?.isclient === 1 ||
    user?.isclient === true ||
    String(user?.isclient).toLowerCase() === 'true'
  );

  // if they aren’t logged in, delegate to your login route
  if (!user?.userid) {
    return <Navigate to="/" replace state={{ from: location }} />;
  }

  // block clients from internal-only routes
  if (isClient) {
    return <Navigate to="/dashboard" replace />;
  }

  return children;
}